<template>
  <div id="app" class="site-modern" v-cloak>
    <site-header></site-header>
    <div class="site-content-wrapper">
      <router-view />
    </div>
    <site-footer></site-footer>
  </div>
</template>
<script>
import "@/assets/css/global.css";

export default {
  components: {
    siteHeader: () => import("@/components/Header"),
    siteFooter: () => import("@/components/Footer")
  },
  mounted() {
    let srcLan = this.$i18n.locale;
    if (srcLan.indexOf('en') != -1) {
      srcLan = 'en';
    } else {
      srcLan = 'zh';
    }

    if (window.location.href.indexOf('mltcloud.com') != -1) {
      srcLan += '_ml';
    }
    this.$i18n.locale = srcLan;
    this.$forceUpdate();
  },
};
</script>

<style lang="stylus">
[v-cloak] {
  display: none;
}

.site-modern {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.site-content-wrapper {
  flex: 1;
}

* {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  background: #f8f9fa;
}
</style>
